export const getNotificationLink = (urlOrPath: string): string => {
  try {
    // Firestore の url にはパスも含まれる
    const url = new URL(
      urlOrPath.startsWith('http') ? urlOrPath : `${ORIGIN}/${urlOrPath}`,
    );
    url.searchParams.set('ref', 'notification');
    // ホストが同じ場合はホストを削除する
    return url.toString().replace(new RegExp(`^${ORIGIN}`), '');
  } catch {
    return urlOrPath;
  }
};

const ORIGIN = window.location.href.match(/^https?:\/\/[^/]+/)?.[0];
